import { ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Logout } from '@mui/icons-material'
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { useLogout } from '@/api/user-manager'
import { NewFeatureChip } from '@/components/new-feature-chip'
import { isViewAs } from '@/helpers'
import AlumeLogo from '@/assets/images/logo-alume-invertido.svg'
import { NavItem } from './navigation/types'

const DRAWER_WIDTH = 300

type DesktopNavigationProps = {
  items: NavItem[]
  sidebarCard: ReactNode
}

export function DesktopNavigation({
  items,
  sidebarCard,
}: DesktopNavigationProps) {
  const { pathname } = useLocation()
  const { mutateAsync: logout } = useLogout()

  return (
    <Drawer
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: DRAWER_WIDTH,
          boxSizing: 'border-box',
          gap: 3,
          color: 'white',
          bgcolor: (theme) => theme.palette.primary.main,
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <img
        src={AlumeLogo}
        alt="Alume"
        width={120}
        style={{ margin: '12px auto 0 auto' }}
      />

      <List sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {items.map(({ name, route, icon, hide, isNew }) => (
          <ListItem
            key={route}
            disablePadding
            sx={{ mb: 1, display: hide ? 'none' : 'flex' }}
          >
            <ListItemButton
              component={Link}
              to={route}
              selected={pathname === route}
              sx={{
                borderRadius: '100px',
                '&.Mui-selected, &.MuiListItemButton-root:hover': {
                  bgcolor: (theme) => theme.palette.primary.light,
                },
              }}
            >
              <ListItemIcon sx={{ color: 'white' }}>{icon}</ListItemIcon>
              <ListItemText primary={name} />
              {isNew && <NewFeatureChip />}
            </ListItemButton>
          </ListItem>
        ))}

        <Box flex={1} />

        <Box sx={{ mb: 2 }}>{sidebarCard}</Box>

        {!isViewAs() && (
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => logout()}
            sx={{
              borderRadius: '100px',
              '&.Mui-selected, &.MuiListItemButton-root:hover': {
                bgcolor: (theme) => theme.palette.primary.light,
              },
            }}
          >
            <ListItemIcon sx={{ color: 'white' }}>
              <Logout />
            </ListItemIcon>
            <ListItemText primary="Sair da conta" />
          </ListItemButton>
        </ListItem>
        )}
      </List>
    </Drawer>
  )
}
